import { createContext } from "react";

export interface GridLayoutContextValue {
	dragHandleClassName: string;
	dragCancelClassName: string;
}

export const GridLayoutContext = createContext<null | GridLayoutContextValue>(null);

export const GridLayoutContextProvider = GridLayoutContext.Provider;
